import {
  DEFAULT_PRINT_PAGE_SIZE,
  PRINT_PAGE_SIZES,
} from 'constants/printPageSize';

// Layout tokens consumed by the picklist templates in utils/pdfGenerators.
// Everything that has to scale with the paper lives here so the two
// templates (barcode / batch_code) stay in sync.
const PICKLIST_PRINT_LAYOUTS = {
  [PRINT_PAGE_SIZES.LABEL_4X6]: {
    pageSize: '100mm 150mm',
    pageMargin: '5mm',
    bodyWidth: '90mm',
    bodyHeight: '140mm',
    bodyFontSize: '7px',
    cellFontSize: '6px',
    cellPadding: '1px',
    titleFontSize: '10px',
    headerFontSize: '7px',
    headerBarcodeTextSize: '9px',
    barcodeTextSize: '6px',
    barcodeHeight: 20,
    barcodeBarWidth: 0.8,
    partitionFontSize: '12px',
    qrSize: 70,
    qrLabelSize: '6px',
  },
  [PRINT_PAGE_SIZES.A4]: {
    pageSize: 'A4',
    pageMargin: '10mm',
    bodyWidth: '190mm',
    bodyHeight: null,
    bodyFontSize: '11px',
    cellFontSize: '10px',
    cellPadding: '3px',
    titleFontSize: '18px',
    headerFontSize: '11px',
    headerBarcodeTextSize: '13px',
    barcodeTextSize: '9px',
    barcodeHeight: 40,
    barcodeBarWidth: 1.2,
    partitionFontSize: '18px',
    qrSize: 100,
    qrLabelSize: '9px',
  },
};

export const getPicklistPrintLayout = pageSize =>
  PICKLIST_PRINT_LAYOUTS[pageSize] ??
  PICKLIST_PRINT_LAYOUTS[DEFAULT_PRINT_PAGE_SIZE];
